export const PHONE_VERIFICATION_CODE_LENGTH = 6
export const TOTP_LENGTH = 6

export const GOOGLE_AUTHENTICATOR = {
  APP_STORE_LINK:
    'https://apps.apple.com/us/app/google-authenticator/id388497605',
  GOOGLE_PLAY_LINK:
    'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2',
}
